var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAw = function SvgAw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h288v216H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.2222)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39c",
    d: "M0 0v216h324V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 144v12h324v-12H0zm0 24v12h324v-12H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M142.647 28.067l2.952 2.952-2.953-2.953zm-2.952 5.903l2.952 2.953-2.952-2.952m5.904 0l2.95 2.953-2.95-2.952z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M139.695 36.923l2.952 2.952-2.952-2.952m5.904 0l2.95 2.952-2.95-2.952z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M136.743 42.827l2.952 2.952-2.952-2.953z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M142.647 42.827l2.952 2.952-2.953-2.953z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M148.55 42.827l2.953 2.952-2.952-2.953z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M136.743 45.78l2.952 2.95-2.952-2.95zm11.807 0l2.953 2.95-2.952-2.95z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M139.695 48.73l2.952 2.954-2.952-2.953m5.904 0l2.95 2.954-2.95-2.953z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M133.79 51.684l2.953 2.952-2.952-2.952z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16 34.065l-20.695 78.45-78.68 21.367 78.453 20.476 20.922 78.45 20.918-78.45 78.452-20.922-78.452-20.922-20.918-78.45z",
    stroke: "#fff",
    strokeWidth: 3.69,
    fill: "#c00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M151.503 51.684l2.952 2.952-2.952-2.952z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M133.79 54.636l2.953 2.952-2.952-2.952m17.713 0l2.952 2.952-2.952-2.952z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M136.743 57.588l2.952 2.952-2.952-2.952m11.808 0l2.953 2.952-2.952-2.952z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M130.838 60.54l2.953 2.952-2.952-2.952z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M137.726 62.51l.984 1.967-.984-1.968m11.808 0l.984 1.967-.984-1.968z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M154.455 60.54l2.952 2.952-2.952-2.952z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M130.838 63.492l2.953 2.952-2.952-2.952m23.617 0l2.952 2.952-2.952-2.952z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M133.79 66.444l2.953 2.952-2.952-2.952m17.713 0l2.952 2.952-2.952-2.952z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M127.886 69.396l2.952 2.952-2.952-2.952zm29.521 0l2.952 2.952-2.953-2.952z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M127.886 72.348l2.952 2.952-2.952-2.952m29.52 0l2.953 2.952-2.953-2.952z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M127.886 75.3l2.952 2.952-2.952-2.952m29.52 0l2.953 2.952-2.953-2.952z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M124.934 78.252l2.952 2.952-2.952-2.952z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M130.838 78.252l2.953 2.952-2.952-2.952m23.617 0l2.952 2.952-2.952-2.952z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M160.36 78.252l2.95 2.952-2.95-2.952z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M124.934 81.204l2.952 2.953-2.952-2.952z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M131.82 83.174l.986 1.967-.985-1.966m23.618 0l.984 1.967-.984-1.966z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M160.36 81.204l2.95 2.953-2.95-2.952z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M124.934 84.157l2.952 2.952-2.952-2.953m35.425 0l2.95 2.952-2.95-2.953z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M127.886 87.11l2.952 2.95-2.952-2.95m29.52 0l2.953 2.95-2.953-2.95z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M121.982 90.06l2.952 2.953-2.952-2.952z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M128.87 92.03l.984 1.968-.985-1.968m29.52 0l.985 1.968-.985-1.968z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M163.31 90.06l2.954 2.953-2.953-2.952z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M121.982 93.013l2.952 2.952-2.952-2.952m41.33 0l2.952 2.952-2.953-2.952z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M124.934 95.965l2.952 2.952-2.952-2.952m35.425 0l2.95 2.952-2.95-2.952z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M119.03 98.917l2.952 2.952-2.952-2.953z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M125.917 100.886l.984 1.968-.983-1.968m35.425 0l.985 1.968-.985-1.968z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M166.264 98.917l2.952 2.952-2.952-2.953z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M119.03 101.87l2.952 2.95-2.952-2.95m47.234 0l2.952 2.95-2.952-2.95z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M121.982 104.82l2.952 2.953-2.952-2.952m41.33 0l2.952 2.953-2.953-2.952z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M116.078 107.773l2.952 2.952-2.952-2.952z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M121.982 107.773l2.952 2.952-2.952-2.952m41.33 0l2.952 2.952-2.953-2.952z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M169.216 107.773l2.952 2.952-2.952-2.952m-61.994 2.952l2.952 2.953-2.952-2.952z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M110.174 110.725l2.952 2.953-2.952-2.952m64.946 0l2.952 2.952-2.952-2.952z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M178.072 110.725l2.952 2.953-2.952-2.952m-79.707 2.952l2.952 2.952-2.952-2.952z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M101.317 113.678l2.953 2.952-2.953-2.952z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M113.126 113.678l2.952 2.952-2.952-2.952z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M116.078 113.678l2.952 2.952-2.952-2.952m53.138 0l2.952 2.952-2.952-2.952z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M172.168 113.678l2.952 2.952-2.952-2.952z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M183.976 113.678l2.952 2.952-2.952-2.952z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M186.928 113.678l2.952 2.952-2.952-2.952z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M86.557 116.63l2.952 2.952-2.953-2.952z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M89.51 116.63l2.95 2.952-2.95-2.952z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M92.46 116.63l2.953 2.952-2.952-2.952z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M104.27 116.63l2.952 2.952-2.952-2.952z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M109.19 117.613l1.97.984-1.97-.984m67.9 0l1.967.984-1.968-.984z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M181.024 116.63l2.952 2.952-2.952-2.952z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M192.833 116.63l2.952 2.952-2.952-2.952z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M195.785 116.63l2.952 2.952-2.952-2.952z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M198.737 116.63l2.952 2.952-2.953-2.952M77.7 119.582l2.953 2.952-2.952-2.952z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M80.653 119.582l2.952 2.952-2.952-2.952z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M83.605 119.582l2.952 2.952-2.952-2.952z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M95.413 119.582l2.952 2.952-2.952-2.952z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M100.334 120.565l1.968.984-1.968-.985m85.61 0l1.97.984-1.97-.985z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M189.88 119.582l2.953 2.952-2.953-2.952z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M201.69 119.582l2.95 2.952-2.95-2.952z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M204.64 119.582l2.953 2.952-2.952-2.952z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M207.593 119.582l2.952 2.952-2.952-2.952m-138.75 2.952l2.953 2.952-2.952-2.952z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M71.796 122.534l2.952 2.952-2.952-2.952z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M86.557 122.534l2.952 2.952-2.953-2.952z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M91.478 123.517l1.968.984-1.968-.983m103.324 0l1.967.984-1.968-.983z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M198.737 122.534l2.952 2.952-2.953-2.952z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M213.497 122.534l2.952 2.952-2.953-2.952z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M216.45 122.534l2.95 2.952-2.95-2.952z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M59.988 125.486l2.952 2.952-2.952-2.952z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M62.94 125.486l2.952 2.952-2.952-2.952z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M74.75 125.486l2.95 2.952-2.95-2.952zm135.795 0l2.952 2.952-2.952-2.952z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M222.353 125.486l2.953 2.952-2.953-2.952z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M225.306 125.486l2.952 2.952-2.952-2.952m-174.174 2.952l2.952 2.952-2.952-2.952z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M54.084 128.438l2.952 2.952-2.952-2.952z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M65.892 128.438l2.952 2.952-2.952-2.952z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M70.813 129.42l1.968.985-1.967-.984m144.653 0l1.968.985-1.968-.984z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M219.4 128.438l2.954 2.952-2.953-2.952z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M231.21 128.438l2.952 2.952-2.952-2.952z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M234.162 128.438l2.952 2.952-2.952-2.952z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M42.275 131.39l2.952 2.952-2.952-2.952z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M45.227 131.39l2.953 2.952-2.952-2.952z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M57.036 131.39l2.952 2.952-2.952-2.952zm171.222 0l2.952 2.952-2.952-2.952z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M240.066 131.39l2.952 2.952-2.952-2.952z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M243.018 131.39l2.952 2.952-2.952-2.952M36.37 134.342l2.953 2.952-2.952-2.952z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M51.132 134.342l2.952 2.952-2.952-2.952zm183.03 0l2.952 2.952-2.952-2.952z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M248.922 134.342l2.953 2.952-2.953-2.952m-206.647 2.952l2.952 2.953-2.952-2.953z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M45.227 137.294l2.953 2.953-2.952-2.953z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M57.036 137.294l2.952 2.953-2.952-2.953m171.222 0l2.952 2.953-2.952-2.953z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M240.066 137.294l2.952 2.953-2.952-2.953z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M243.018 137.294l2.952 2.953-2.952-2.953z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M51.132 140.247l2.952 2.952-2.952-2.953z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M54.084 140.247l2.952 2.952-2.952-2.953z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M65.892 140.247l2.952 2.952-2.952-2.953z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M70.813 141.23l1.968.984-1.967-.984m144.653 0l1.968.984-1.968-.984z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M219.4 140.247l2.954 2.952-2.953-2.953z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M231.21 140.247l2.952 2.952-2.952-2.953z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M234.162 140.247l2.952 2.952-2.952-2.953M59.988 143.2l2.952 2.95-2.952-2.95z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M62.94 143.2l2.952 2.95-2.952-2.95z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M74.75 143.2l2.95 2.95-2.95-2.95zm135.795 0l2.952 2.95-2.952-2.95z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M222.353 143.2l2.953 2.95-2.953-2.95z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M225.306 143.2l2.952 2.95-2.952-2.95z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M68.844 146.15l2.952 2.953-2.952-2.952z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M71.796 146.15l2.952 2.953-2.952-2.952z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M86.557 146.15l2.952 2.953-2.953-2.952z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M91.478 147.134l1.968.984-1.968-.984m103.324 0l1.967.984-1.968-.984z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M198.737 146.15l2.952 2.953-2.953-2.952z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M213.497 146.15l2.952 2.953-2.953-2.952z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M216.45 146.15l2.95 2.953-2.95-2.952M77.7 149.104l2.953 2.952-2.952-2.952z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M80.653 149.103l2.952 2.952-2.952-2.952z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M83.605 149.103l2.952 2.952-2.952-2.952z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M95.413 149.103l2.952 2.952-2.952-2.952z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M100.334 150.086l1.968.984-1.968-.984m85.61 0l1.97.984-1.97-.984z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M189.88 149.103l2.953 2.952-2.953-2.952z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M201.69 149.103l2.95 2.952-2.95-2.952z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M204.64 149.103l2.953 2.952-2.952-2.952z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M207.593 149.103l2.952 2.952-2.952-2.952m-121.036 2.952l2.952 2.952-2.953-2.952z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M89.51 152.055l2.95 2.952-2.95-2.952z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M92.46 152.055l2.953 2.952-2.952-2.952z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M104.27 152.055l2.952 2.952-2.952-2.952z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M109.19 153.038l1.97.984-1.97-.984m67.9 0l1.967.984-1.968-.984z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M181.024 152.055l2.952 2.952-2.952-2.952z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M192.833 152.055l2.952 2.952-2.952-2.952z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M195.785 152.055l2.952 2.952-2.952-2.952z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M198.737 152.055l2.952 2.952-2.953-2.952z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M98.365 155.007l2.952 2.952-2.952-2.953z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M101.317 155.007l2.953 2.952-2.953-2.953z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M113.126 155.007l2.952 2.952-2.952-2.953z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M116.078 155.007l2.952 2.952-2.952-2.953m53.138 0l2.952 2.952-2.952-2.953z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M172.168 155.007l2.952 2.952-2.952-2.953z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M183.976 155.007l2.952 2.952-2.952-2.953z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M186.928 155.007l2.952 2.952-2.952-2.953m-79.706 2.952l2.952 2.95-2.952-2.95z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M110.174 157.96l2.952 2.95-2.952-2.95m64.946 0l2.952 2.95-2.952-2.95z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M178.072 157.96l2.952 2.95-2.952-2.95m-61.994 2.95l2.952 2.953-2.952-2.952z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M121.982 160.91l2.952 2.953-2.952-2.952m41.33 0l2.952 2.953-2.953-2.952z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M169.216 160.91l2.952 2.953-2.952-2.952z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M121.982 163.863l2.952 2.952-2.952-2.952m41.33 0l2.952 2.952-2.953-2.952z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M119.03 166.815l2.952 2.953-2.952-2.953z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M125.917 168.784l.984 1.968-.983-1.968m35.425 0l.985 1.968-.985-1.968z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M166.264 166.815l2.952 2.953-2.952-2.953z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M119.03 169.768l2.952 2.952-2.952-2.952m47.234 0l2.952 2.952-2.952-2.952z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M124.934 172.72l2.952 2.952-2.952-2.952m35.425 0l2.95 2.952-2.95-2.952z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M121.982 175.672l2.952 2.952-2.952-2.952z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M128.87 177.64l.984 1.97-.985-1.97m29.52 0l.985 1.97-.985-1.97z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M163.31 175.672l2.954 2.952-2.953-2.952z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M121.982 178.624l2.952 2.952-2.952-2.952m41.33 0l2.952 2.952-2.953-2.952z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M127.886 181.576l2.952 2.952-2.952-2.952m29.52 0l2.953 2.952-2.953-2.952z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M124.934 184.528l2.952 2.952-2.952-2.952z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M131.82 186.497l.986 1.968-.985-1.968m23.618 0l.984 1.968-.984-1.968z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M160.36 184.528l2.95 2.952-2.95-2.952z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M124.934 187.48l2.952 2.952-2.952-2.952m35.425 0l2.95 2.952-2.95-2.952z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M124.934 190.432l2.952 2.952-2.952-2.952z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M130.838 190.432l2.953 2.952-2.952-2.952m23.617 0l2.952 2.952-2.952-2.952z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M160.36 190.432l2.95 2.952-2.95-2.952z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M127.886 193.384l2.952 2.952-2.952-2.952zm29.521 0l2.952 2.952-2.953-2.952z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M127.886 196.336l2.952 2.953-2.952-2.954m29.52 0l2.953 2.953-2.953-2.954z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M127.886 199.29l2.952 2.95-2.952-2.95m29.52 0l2.953 2.95-2.953-2.95z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M133.79 202.24l2.953 2.953-2.952-2.952m17.713 0l2.952 2.953-2.952-2.952z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M130.838 205.193l2.953 2.952-2.952-2.952z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M137.726 207.162l.984 1.968-.984-1.968m11.808 0l.984 1.968-.984-1.968z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M154.455 205.193l2.952 2.952-2.952-2.952z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M130.838 208.145l2.953 2.952-2.952-2.952m23.617 0l2.952 2.952-2.952-2.952z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M136.743 211.097l2.952 2.952-2.952-2.953m11.808 0l2.953 2.952-2.952-2.953z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M133.79 214.05l2.953 2.95-2.952-2.95zm17.713 0l2.952 2.95-2.952-2.95z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M133.79 217l2.953 2.953L133.79 217m17.713 0l2.952 2.953-2.952-2.952z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M139.695 219.953l2.952 2.952-2.952-2.952m5.904 0l2.95 2.952-2.95-2.952z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M136.743 222.905l2.952 2.952-2.952-2.952m11.808 0l2.953 2.952-2.952-2.952z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M136.743 225.857l2.952 2.953-2.952-2.953z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M142.647 225.857l2.952 2.953-2.953-2.953z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M148.55 225.857l2.953 2.953-2.952-2.953z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M139.695 231.762l2.952 2.952-2.952-2.952m5.904 0l2.95 2.952-2.95-2.952z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M139.695 234.714l2.952 2.952-2.952-2.952m5.904 0l2.95 2.952-2.95-2.952m-2.953 5.904l2.952 2.952-2.953-2.952z"
  })));
};
export default __webpack_public_path__ + "assets/530a7832ea5c0553b29c5473181d731a.svg";
export { SvgAw as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/aw.svg